module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.commentShow) ? _c('footer', [_c('div', {
    staticClass: "m-footer-layout-bar"
  }, [_c('div', {
    staticClass: "m-fixed-b m-footer-bar"
  }, [_c('input', {
    staticClass: "fz14 m-footer-bar-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "value": "我来说两句.."
    },
    on: {
      "click": _vm.showComment
    }
  }), _vm._v(" "), (_vm.appInfo) ? _c('span', {
    staticClass: "m-footer-share fz14",
    on: {
      "click": _vm.showShare
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.share
    }
  }), _c('span', [_vm._v("分享")])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-808390b6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 212
// module chunks = 1